@if (show()) {
  <button
    mat-stroked-button
    type="button"
    class="version-switch"
    [matTooltip]="tooltip()"
    (click)="switchToNewPortal()">
    {{ buttonLabel() }}
  </button>
}
